import * as React from 'react';
import { Input } from '~/components/Controls/Input';
import { SelectInput } from '~/components/Controls/Select';
import { adTypes, placementTypes, platforms } from '~/modules/Sources/forms/PlacementForm';
import { usePlacements } from '~/modules/Sources/usePlacements';

interface IPlacementsSearchProps {
    placements: ReturnType<typeof usePlacements>;
    className?: string;
}

export const PlacementsSearch: React.FC<IPlacementsSearchProps> = ({ placements, className }) => (
    <div className={className}>
        <Input
            value={placements.q}
            onChange={value => placements.search({ q: value })}
            placeholder="Search by name or ID"
            rightIcon={<i className="fa fa-search input-search-icon" />}
        />
        <Input
            value={placements.bundle}
            onChange={value => placements.search({ bundle: value })}
            placeholder="Bundle"
            rightIcon={<i className="fa fa-search input-search-icon" />}
        />
        <SelectInput
            items={platforms}
            value={placements.platform}
            onChange={value => placements.search({ platform: value ?? '' })}
            placeholder="Platform"
            clearable
        />
        <SelectInput
            items={adTypes}
            value={placements.adType}
            onChange={value => placements.search({ adType: value ?? '' })}
            placeholder="Ad type"
            clearable
        />
        <SelectInput
            items={placementTypes}
            value={placements.placementType}
            onChange={value => placements.search({ placementType: value ?? '' })}
            placeholder="Placement type"
            clearable
        />
    </div>
);
